import { createFileRoute } from '@tanstack/react-router'

import { CompanyGlossariesScreen } from '@/features/glossary'

export const Route = createFileRoute('/_auth/admin/glossaries/')({
  component: GlossariesRoute,
})

function GlossariesRoute() {
  const navigate = Route.useNavigate()
  return (
    <CompanyGlossariesScreen
      onOpen={(glossaryId) => void navigate({ to: '/admin/glossaries/$glossaryId', params: { glossaryId } })}
    />
  )
}
